/* eslint arrow-parens: ["error", "as-needed"] */
/* eslint no-case-declarations: [0] */
import moment from 'moment';
import Enums from 'utils/EnumsManager';
import { toTimezone } from 'utils/dateTimeUtils';
import { MERGE_SUCCESS, RESET, SET_DATA, SET_MASTER_RECORD, SET_MERGED_DATA } from './actionTypes';
import { setDefaultCheckedData } from './utils';

const { FieldTypes, MasterKey } = Enums;
const {
  DateOnly,
  DateTime,
  Display,
  Lookup,
} = FieldTypes;

const parseKeys = keys => {
  const masterKey = {
    is_merge_master: false,
    field_name: MasterKey, // this is the field we use as a key to sync with backend for changes
    field_label: '',
    crm_data_type: Display,
    lookupKey: '',
  };
  const restKeys = keys.filter(key => key.field_name !== MasterKey);
  return [masterKey, ...restKeys].map(key => ({
    isFollowMaster: !!key.is_merge_master,
    key: key.field_name, // this is the field we use as a key to sync with backend for changes
    label: key.field_label,
    type: key.crm_data_type,
    lookupKey: key.lookup_own_field_name,
  }));
};

const convertToTimeZone = (data, keys) => {
  data.forEach(record => {
    keys.forEach(key => {
      if (key.type === DateOnly || key.type === DateTime) {
        record[key.key] = record[key.key] === null ? null : toTimezone(record[key.key], key.type === DateTime);
      }
    });
  });
};

const DATETIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';

const initialState = {
  data: [],
  keys: [],
  mergedData: {},
  newMergedId: '',
  mergeSuccess: false,
};

const mergence = (state = initialState, action) => {
  switch (action.type) {
    case SET_DATA:
      const { originalKeys, data } = action.payload;
      // parse original keys
      const parsedKeys = parseKeys(originalKeys);
      // process data of Date, Datetime
      convertToTimeZone(data, parsedKeys);
      // process default checked fields
      const mergedData = setDefaultCheckedData(parsedKeys, data);
      return {
        ...state,
        keys: parsedKeys,
        data,
        mergedData,
      };


    case SET_MERGED_DATA:
      const { key, value } = action.payload;
      if (!key) return state;
      return {
        ...state,
        mergedData: {
          ...state.mergedData,
          [key]: value,
        },
      };


    case SET_MASTER_RECORD:
      const { masterId } = action.payload;
      const masterRecord = state.data.find(record => record.id === masterId);
      const masteredFields = {};

      const getFieldValue = keyName => {
        if (masterRecord[keyName]) {
          return masterRecord[keyName];
        }

        // if masterRecord do not have value , get latest value from other leads
        const otherFieldValues = state.data.filter(record => record[keyName])
          .sort((a, b) => {
            const aMoment = a.last_modified_date ? moment(a.last_modified_date, DATETIME_FORMAT) : moment(a.created_at, DATETIME_FORMAT);
            const bMoment = b.last_modified_date ? moment(b.last_modified_date, DATETIME_FORMAT) : moment(b.created_at, DATETIME_FORMAT);
            return bMoment.isSameOrAfter(aMoment) ? 1 : -1;
          }).map(record => record[keyName]);

        if (otherFieldValues.length > 0) {
          return otherFieldValues[0];
        }

        return null;
      };

      state.keys.forEach(key => {
        masteredFields[key.key] = getFieldValue(key.key);
        if (key.type === Lookup) {
          masteredFields[key.key] = masteredFields[key.key]
            ? masteredFields[key.key].id
            : null;
        }
      });

      return {
        ...state,
        mergedData: {
          ...state.mergedData,
          ...masteredFields,
          id: masterId,
          master_record_id: masterId,
        },
      };


    case MERGE_SUCCESS:
      const { newMergedId } = action.payload;
      return {
        ...state,
        mergeSuccess: true,
        newMergedId,
      };


    case RESET:
      return initialState;


    default:
      return state;
  }
};

export default mergence;



// WEBPACK FOOTER //
// ./src/views/MergeLeads/flow/reducer.js